import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const GetAdmissionsDischargesChartRequestDtoSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  facilityId: z.number().optional(),
});

const SparkLineDtoSchema = z.object({
  granularity: z.enum(['day', 'week', 'month']),
  points: z.array(SparkLinePointDtoSchema),
});

const GetAdmissionsDischargesChartResponseDtoSchema = z.object({
  admissions: SparkLineDtoSchema,
  discharges: SparkLineDtoSchema,
});

export type GetAdmissionsDischargesChartRequestDto = z.infer<
  typeof GetAdmissionsDischargesChartRequestDtoSchema
>;
export type GetAdmissionsDischargesChartResponseDto = z.infer<
  typeof GetAdmissionsDischargesChartResponseDtoSchema
>;

export const getAdmissionsDischargesChart = (
  params: GetAdmissionsDischargesChartRequestDto,
  config?: AxiosRequestConfig<GetAdmissionsDischargesChartRequestDto>
) => {
  const validatedParams =
    GetAdmissionsDischargesChartRequestDtoSchema.parse(params);
  return api
    .get('/residents/admissions-discharges-chart', {
      params: validatedParams,
      ...config,
    })
    .then(responseContract(GetAdmissionsDischargesChartResponseDtoSchema));
};
